/** 입력 화면들이 공유하는 작은 조각들. */
import type { ReactNode } from "react";
import type { ValveType } from "../calc/gas";
import { FIELD_HELP, type FieldHelpKey } from "./fieldHelp";

export const VALVE_LABELS: Record<ValveType, string> = {
  conventional: "일반형 (Conventional)",
  "pilot-operated": "파일럿형 (Pilot-operated)",
  "balanced-bellows": "밸런스드 벨로우즈 (Balanced bellows)",
};

/** 문자열 입력을 숫자로. 비어 있거나 잘못된 값은 NaN 이 되어 계산 쪽에서 거부된다. */
export function num(s: string): number {
  const v = Number.parseFloat(s);
  return Number.isFinite(v) ? v : Number.NaN;
}

/**
 * 입력 항목 옆의 도움말 배지.
 *
 * 마우스를 올리면 설명이 뜨고 치우면 사라진다. 키보드로도 닿을 수 있게
 * `tabIndex` 를 주고 `:focus-visible` 에서도 뜨게 했다 — 마우스를 쓰지
 * 않는 사용자가 설명을 못 보는 일이 없도록.
 *
 * 브라우저 기본 `title` 툴팁을 쓰지 않은 이유: 뜨기까지 1초 넘게 걸리고
 * 줄바꿈·길이 제어가 안 된다. 설명이 길어 읽히지 않으면 없는 것과 같다.
 */
export function Help({ topic }: { topic: FieldHelpKey }) {
  const text = FIELD_HELP[topic];
  return (
    <span className="help" tabIndex={0} role="note" aria-label={text}>
      <span aria-hidden="true">?</span>
      <span className="help__bubble">{text}</span>
    </span>
  );
}

export function Field({
  label,
  unit,
  help,
  children,
}: {
  label: string;
  unit: string;
  /** 도움말 문구 키. 주면 라벨 옆에 물음표 배지가 붙는다. */
  help?: FieldHelpKey;
  children: ReactNode;
}) {
  return (
    <label className="grid-form__field">
      <span className="grid-form__label">
        {label} {unit && <em className="muted">{unit}</em>}
        {help && <Help topic={help} />}
      </span>
      {children}
    </label>
  );
}

export function Item({ label, value }: { label: string; value: string }) {
  return (
    <div>
      <dt>{label}</dt>
      <dd>{value}</dd>
    </div>
  );
}
